import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import { useStore } from 'effector-react';
import React, { FunctionComponent, useEffect } from 'react';
import platforms from '@stores/platforms';
import css from './GameEditModal.module.less';

interface GameEditModalPlatformsProps {
  onChange?: (e: any) => void;
  value?: Array<CheckboxValueType>;
}

const GameEditModalPlatforms: FunctionComponent<GameEditModalPlatformsProps> = ({
  onChange,
  value = [],
}: GameEditModalPlatformsProps) => {
  const [checkedList, setCheckedList] = React.useState<Array<any>>(value);
  const [indeterminate, setIndeterminate] = React.useState<boolean>(true);
  const [checkAll, setCheckAll] = React.useState(false);
  const { basePlatforms, otherPlatforms } = useStore(platforms);

  const onCheckAllChange = (event: CheckboxChangeEvent) => {
    setCheckedList(event.target.checked ? Object.values(basePlatforms) : []);
    setIndeterminate(false);
    setCheckAll(event.target.checked);
  };

  const onGroupChange = (groupValue: Array<CheckboxValueType>) => {
    const isIndeterminate = groupValue.length <= Object.keys(basePlatforms).length;
    setCheckedList(groupValue);
    setIndeterminate(isIndeterminate);
    setCheckAll(!isIndeterminate);
  };

  useEffect(() => {
    onChange && onChange(checkedList);

    // eslint-disable-next-line
  }, [checkedList]);

  useEffect(() => {
    if (checkedList?.length > Object.keys(basePlatforms)?.length) {
      setCheckAll(true);
      setIndeterminate(false);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Checkbox indeterminate={indeterminate} onChange={onCheckAllChange} checked={checkAll}>
        All
      </Checkbox>
      <Checkbox.Group onChange={onGroupChange} value={value}>
        {Object.entries({ ...basePlatforms, ...otherPlatforms }).map(
          ([platformName, platformId]) => {
            return (
              <Checkbox value={platformId} key={platformName} className={css.groupCheckbox}>
                {platformName}
              </Checkbox>
            );
          },
        )}
      </Checkbox.Group>
    </>
  );
};

export default GameEditModalPlatforms;
